var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 8.5C0 3.808 3.8 0 8.492 0 13.192 0 17 3.808 17 8.5S13.192 17 8.492 17C3.799 17 0 13.192 0 8.5zm1.7 0c0 3.757 3.043 6.8 6.8 6.8 3.757 0 6.8-3.043 6.8-6.8 0-3.757-3.043-6.8-6.8-6.8a6.798 6.798 0 0 0-6.8 6.8zm5.95-4.25h1.275v4.462l3.825 2.27-.637 1.046L7.65 9.35v-5.1z",
  clipRule: "evenodd"
})));
export default SvgClock;